/** @format */

import {v4} from 'uuid';

import {Space, SpaceList} from 'pages/Home/DigitalCast/models/spaces';

const newSpace = (spaceList: SpaceList | null): SpaceList => {
  const spacesCount = Object.keys(spaceList || {}).length;
  const id = v4();

  const newSpace: Space = {
    id,
    title: `Рабочее пространство ${spacesCount + 1}`,
    order: spacesCount,
    widgetsBoardSelected: ['budget', 'notes'],
    widgetsSettings: {
      budget: {
        calcMethod: 'day',
      },
      notes: {},
    },
    widgetsMenuSelected: ['budget', 'notes'],
    chartSelected: {
      current: ['budget', 'notes'],
      previous: [],
    },
  };

  return {
    ...spaceList,
    [id]: newSpace,
  };
};

export default newSpace;
